import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './components/pages/HomePage';
import UnsubscribeConfirmation from './components/sections/unsubscribe/UnsubscribeConfirmation';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <div className="min-h-screen">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/unsubscribe" element={<UnsubscribeConfirmation />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;